import { DefaultService } from '@/services/DefaultService';

export default class AtividadeService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

    findAll(page = 0, limit = 50, ...param) {
        return this._http.get(encodeURI(`${this._env}/activity/atividades.json?page=${page}&limit=${limit}&param=${param}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
    find(id) {
        return this._http.get(`${this._env}/activity/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

}